import * as quoteChildren from "./children.quotes";
import { baseMeta, metaWithRoles } from "./constants/quoteMeta";

export default [
  quoteChildren.CompanyAndLineOfBusiness,
  {
    path: "/quotes/:quoteId",
    component: () =>
      import(/* webpackChunkName: "quotes" */ "@/views/shared/quotes/Home.vue"),
    props: (route: { params: { quoteId: any } }) => ({
      quoteId: route.params.quoteId
    }),
    meta: {
      ...metaWithRoles,
      pageTitle: "Quote",
      metaTags: { title: "Quote" }
    },
    children: [
      quoteChildren.RiskAddress,
      quoteChildren.Territory,
      quoteChildren.PropertyRating,
      quoteChildren.PropertyRatings,
      quoteChildren.UnderwritingQualifications,
      quoteChildren.LossReportViewer,
      quoteChildren.RatingApplication,
      quoteChildren.RemarksAndMortgages
    ]
  },
  {
    path: "/quotes",
    name: "quotes",
    component: () =>
      import(
        /* webpackChunkName: "quotes" */ "@/views/shared/quotes/QuotesListView/QuotesListView.vue"
      ),
    meta: {
      ...metaWithRoles,
      pageTitle: "Quotes",
      metaTags: { title: "Quotes" }
    },
    props: true
  },
  {
    path: "/quotesPropertyAnalytics/list",
    component: () =>
      import(
        /* webpackChunkName: "quotes-analytics" */ "@/views/shared/quotes/PropertyAnalyticsListView/QuotesPropertyAnalyticsListView.vue"
      ),
    meta: {
      ...baseMeta,
      allowedRoles: ["admin"],
      pageTitle: "Quote Property Analytics",
      breadcrumbs: [{ link: "/quotes", title: "Quotes" }]
    }
  },
  {
    path: "/quotes/xml/:ratingId/:responseTypeLabel",
    component: () =>
      import(
        /* webpackChunkName: "quotes-xml" */ "@/views/shared/quotes/rawXMLViewer.vue"
      ),
    meta: {
      ...baseMeta,
      allowedRoles: ["admin", "agent", "agencyAdmin", "subAdmin"],
      pageTitle: "Sending XML"
    }
  },
  {
    path: "/quotes/:quoteId/view",
    component: () =>
      import(
        /* webpackChunkName: "quotes-view" */ "@/views/shared/quotes/ViewSingleQuote.vue"
      ),
    props: (route: { params: { quoteId: any } }) => ({
      quoteId: route.params.quoteId
    }),
    meta: {
      ...metaWithRoles,
      pageTitle: "View Quote",
      metaTags: { title: "View Quote" },
      breadcrumbs: [{ link: "/quotes", title: "Quotes" }]
    }
  },
  {
    path: "/quotes/:quoteId/view-legacy",
    component: () =>
      import(
        /* webpackChunkName: "quotes-view" */ "@/views/shared/quotes/ViewSingleQuoteLegacy.vue"
      ),
    props: (route: { params: { quoteId: any } }) => ({
      quoteId: route.params.quoteId
    }),
    meta: {
      ...metaWithRoles,
      pageTitle: "View Quote",
      metaTags: { title: "View Quote" },
      breadcrumbs: [{ link: "/quotes?isLegacy=true", title: "Quotes" }]
    }
  }
];
